import { addDays, isoWeek, mondayOf } from '../helpers';
import { YearbookSheet } from '../types';
import { normalizeArticle } from './ArticleNumberCell';

export interface SampleTotal {
  total: number;
  parts: Array<{ chain: string; count: number }>;
  unreadable: number;
}

export const sampleCount = (value: string): number | null => {
  const text = value.trim();
  return /^\d{1,6}$/.test(text) ? Number(text) : null;
};

const weekOf = (date: string): string => `${addDays(mondayOf(date), 3).slice(0, 4)}-${isoWeek(date)}`;

export function sampleTotals(sheets: YearbookSheet[]): Record<string, SampleTotal> {
  const groups = new Map<string, Array<{ rowId: string; chain: string; count: number | null }>>();
  for (const sheet of sheets) {
    for (const row of sheet.rows) {
      const article = normalizeArticle(row.articleNumber || '');
      if (!/\d/.test(article) || row.issues.includes('unsafe_identity') || !row.announcementDate || !row.samples.trim()) continue;
      const key = `${article}|${weekOf(row.announcementDate)}`;
      groups.set(key, [...(groups.get(key) ?? []), { rowId: row.id, chain: sheet.name, count: sampleCount(row.samples) }]);
    }
  }
  const totals: Record<string, SampleTotal> = {};
  for (const entries of Array.from(groups.values())) {
    if (entries.length < 2) continue;
    const counted = entries.filter((entry): entry is { rowId: string; chain: string; count: number } => entry.count !== null);
    if (counted.length === 0) continue;
    const total: SampleTotal = {
      total: counted.reduce((sum, entry) => sum + entry.count, 0),
      parts: counted.map((entry) => ({ chain: entry.chain, count: entry.count })),
      unreadable: entries.length - counted.length,
    };
    for (const entry of entries) totals[entry.rowId] = total;
  }
  return totals;
}
